"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTableConfig = exports.getDefaultColumnConfig = void 0;
const getDefaultColumnConfig = () => [
    {
        id: 'name',
        label: 'Material',
        type: 'text',
        width: 200,
        visible: true,
        locked: true,
        custom: false,
        required: true,
    },
    {
        id: 'quantity',
        label: 'Quantity',
        type: 'number',
        width: 100,
        visible: true,
        locked: false,
        custom: false,
        min: -100000,
        max: 100000,
        decimals: 2,
    },
    {
        id: 'unit',
        label: 'Unit',
        type: 'select',
        width: 100,
        visible: true,
        locked: false,
        custom: false,
        options: ['skeins', 'balls', 'yards', 'meters', 'ounces', 'grams'],
        allow_custom: true,
    },
    {
        id: 'category',
        label: 'Category',
        type: 'select',
        width: 120,
        visible: true,
        locked: false,
        custom: false,
        options: ['Yarn', 'Fabric', 'Thread', 'Notions', 'Tools'],
        allow_custom: true,
    },
    {
        id: 'brand',
        label: 'Brand',
        type: 'text',
        width: 120,
        visible: true,
        locked: false,
        custom: false,
        max_length: 100,
    },
    {
        id: 'color',
        label: 'Color',
        type: 'text',
        width: 100,
        visible: true,
        locked: false,
        custom: false,
        max_length: 50,
    },
    {
        id: 'storage_location',
        label: 'Location',
        type: 'text',
        width: 150,
        visible: true,
        locked: false,
        custom: false,
        max_length: 100,
    },
    {
        id: 'notes',
        label: 'Notes',
        type: 'text',
        width: 200,
        visible: true,
        locked: false,
        custom: false,
        max_length: 500,
        multiline: true,
    },
    {
        id: 'images',
        label: 'Images',
        type: 'text',
        width: 120,
        visible: true,
        locked: false,
        custom: false,
    },
];
exports.getDefaultColumnConfig = getDefaultColumnConfig;
const getDefaultTableConfig = () => ({
    columns: (0, exports.getDefaultColumnConfig)(),
    default_sort: { column: 'name', direction: 'asc' },
    row_height: 'normal',
    custom_column_count: 0,
    max_custom_columns: 100,
});
exports.getDefaultTableConfig = getDefaultTableConfig;
